"use strict";exports.nonCapitalisedWords=["a","an","and","at","but","by","for","if","in","of","on","or","the","to","via"];
//# sourceMappingURL=nonCapitalisedWords.cjs.map
